// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"79":"0075289d","192":"fad1af04","206":"b941bece","336":"c8e2b289","351":"92745848","450":"707207bd","513":"b5163b69","793":"2fb955ab","822":"ae0da132","868":"34038aba","984":"d197b79d"}[chunkId] + "-bundle.js";
};